export default __webpack_public_path__ + "static/media/icon-notifications.c483690b.svg";